import { ICommonIconProps } from './types';
/**
 * -----------------------------------------------------------------------------
 * It render a bunch of boxes and a ticket mark icon.
 */
export function FileReceivedIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M6.998 6.998v-2a2 2 0 0 1 2-2.001h10.005a2 2 0 0 1 2 2v14.006a2 2 0 0 1-2 2.001H8.999a2 2 0 0 1-2.001-2v-2.002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <rect
        height={10.004}
        rx={2}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        width={10.004}
        x={2.996}
        y={6.998}
      />
      <path
        d="M21.004 9.079H13M21.004 15.001H13M9.861 10.962l-2.5 2.501-1.502-1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
